var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from "react";
import { get, isArray } from "lodash";
import { Icon } from "semantic-ui-react";
export var FacetedFilter = function (props) {
    var filterOptions = props.filterOptions, data = props.data, onFilterChange = props.onFilterChange, style = props.style, className = props.className;
    var _a = useState(function () {
        var map = {};
        for (var _i = 0, filterOptions_1 = filterOptions; _i < filterOptions_1.length; _i++) {
            var _a = filterOptions_1[_i], property = _a.property, defaultCollapsed = _a.defaultCollapsed;
            map[property] = !!defaultCollapsed;
        }
        return map;
    }), collapsedMap = _a[0], setCollapsedMap = _a[1];
    var _b = React.useState({}), facetGroupMap = _b[0], setFacetGroupMap = _b[1];
    var _c = React.useState({}), propertyFilterMap = _c[0], setPropertyFilterMap = _c[1];
    useEffect(function () {
        var groupMap = {};
        filterOptions.forEach(function (filterOption) {
            var property = filterOption.property, facetOptions = filterOption.facetOptions;
            // Get data filtered on everything but this property
            var otherPropertyKeys = Object.keys(propertyFilterMap).filter(function (key) { return key !== property; });
            var facetCountData = data.filter(function (item) {
                for (var _i = 0, otherPropertyKeys_1 = otherPropertyKeys; _i < otherPropertyKeys_1.length; _i++) {
                    var key = otherPropertyKeys_1[_i];
                    var conditions = propertyFilterMap[key];
                    var matchesSome = conditions.some(function (condition) {
                        var field = condition.field, value = condition.value;
                        if (isArray(item[field])) {
                            return item[field].includes(value);
                        }
                        return item[field] === value;
                    });
                    if (!matchesSome) {
                        return false;
                    }
                }
                return true;
            });
            var groupings = {};
            for (var _i = 0, facetCountData_1 = facetCountData; _i < facetCountData_1.length; _i++) {
                var item = facetCountData_1[_i];
                var facetValues = get(item, property);
                if (!Array.isArray(facetValues)) {
                    facetValues = [facetValues];
                }
                for (var _a = 0, facetValues_1 = facetValues; _a < facetValues_1.length; _a++) {
                    var facetValue = facetValues_1[_a];
                    if (!groupings[facetValue]) {
                        groupings[facetValue] = [];
                    }
                    groupings[facetValue].push(item);
                }
            }
            // include facet options explicitly added to the groupings
            Object.keys(facetOptions || {}).forEach(function (facet) {
                if (!groupings[facet]) {
                    groupings[facet] = [];
                }
            });
            // sort the keys alphabetically or by facetOptions.sortOrder
            var keys = Object.keys(groupings).sort();
            if (facetOptions) {
                Object.keys(facetOptions).forEach(function (facet) {
                    var sortOrder = facetOptions[facet].sortOrder;
                    if (sortOrder) {
                        var fromIndex = keys.indexOf(facet);
                        var toIndex = sortOrder - 1;
                        var element = keys.splice(fromIndex, 1)[0];
                        keys.splice(toIndex, 0, element);
                    }
                });
            }
            // assemble facet groups
            var groups = [];
            keys.forEach(function (key) {
                var matches = groupings[key];
                var options = (facetOptions || {})[key];
                if (options && ((!options.showZeroes && !matches.length) || options.hidden)) {
                    return;
                }
                var valueForComparison = get(matches[0], property);
                if (Array.isArray(valueForComparison)) {
                    valueForComparison = key; // this should be the facet name itself when looking up in an array
                }
                var explicitLabel = options ? options.label : undefined;
                var group = {
                    facet: explicitLabel || key,
                    options: filterOption,
                    count: matches.length,
                    value: valueForComparison
                };
                groups.push(group);
            });
            groupMap[property] = groups;
        });
        setFacetGroupMap(groupMap);
    }, [filterOptions, data, propertyFilterMap]);
    var togglePropertyCollapsed = function (property) {
        var _a;
        setCollapsedMap(__assign(__assign({}, collapsedMap), (_a = {}, _a[property] = !collapsedMap[property], _a)));
    };
    var setFiltersAndTriggerChange = function (newFilters) {
        Object.keys(newFilters).forEach(function (key) {
            var filters = newFilters[key];
            if (!filters.length) {
                delete newFilters[key];
            }
        });
        var event = {
            filter: {
                logic: "and",
                filters: Object.keys(newFilters).map(function (key) { return ({
                    logic: "or",
                    filters: newFilters[key]
                }); })
            }
        };
        setPropertyFilterMap(newFilters);
        onFilterChange(event);
    };
    var clearPropertyFilters = function (property) {
        var newActiveFilters = __assign({}, propertyFilterMap);
        delete newActiveFilters[property];
        setFiltersAndTriggerChange(newActiveFilters);
    };
    var toggleFilter = function (group) {
        var _a;
        var _b = group.options, property = _b.property, operator = _b.operator, value = group.value;
        var newPropertyFilters = propertyFilterMap[property] || [];
        var newPropertyFilterIndex = newPropertyFilters.findIndex(function (item) { return item.value === value; });
        if (newPropertyFilterIndex === -1) {
            newPropertyFilters.push({
                field: property,
                operator: operator !== null && operator !== void 0 ? operator : "eq",
                value: value
            });
        }
        else {
            newPropertyFilters.splice(newPropertyFilterIndex, 1);
        }
        var newFilters = __assign(__assign({}, propertyFilterMap), (_a = {}, _a[property] = newPropertyFilters, _a));
        setFiltersAndTriggerChange(newFilters);
    };
    var isFilterActive = function (property, value) {
        var existingFilters = propertyFilterMap[property] || [];
        return !!existingFilters.find(function (item) { return item.field === property && item.value === value; });
    };
    return (React.createElement("div", { className: "ff-container " + (className || ""), style: style }, filterOptions.map(function (filterOption) {
        var property = filterOption.property, label = filterOption.label;
        var groups = facetGroupMap[property] || [];
        var isCollapsed = !!collapsedMap[property];
        return (React.createElement("div", { className: "ff-group", key: property },
            React.createElement("div", { className: "ff-group-heading" },
                React.createElement("span", { onClick: function () { return togglePropertyCollapsed(property); } },
                    React.createElement(Icon, { name: isCollapsed ? "chevron right" : "chevron down" }),
                    React.createElement("span", { className: "ff-group-heading-label" }, label || property)),
                React.createElement("span", { onClick: function () { return clearPropertyFilters(property); } },
                    React.createElement(Icon, { name: "refresh" }),
                    React.createElement("span", { className: "ff-group-heading-label" }, "Clear"))),
            React.createElement("div", { className: "ff-collapse " + (isCollapsed ? "ff-in" : "") }, groups.map(function (group) {
                var facet = group.facet, count = group.count, property = group.options.property, value = group.value;
                return (React.createElement("button", { type: "button", className: "ff-group-item " + (isFilterActive(property, value) ? "ff-group-item-active" : ""), key: facet, title: facet, onClick: function () { return toggleFilter(group); } },
                    React.createElement("span", { className: "ff-facet-label" }, facet),
                    React.createElement("span", { className: "ff-facet-count" }, count)));
            }))));
    })));
};
//# sourceMappingURL=FacetedFilter.js.map